const STORAGE_KEY = 'collection-grid-columns';
const COLUMNS = ['7', '6', '5', '4', '3'];
const ALLOWED = new Set(COLUMNS);
const DEFAULT_COLUMNS = '5';
const MOBILE_MQ = '(max-width: 989px)';

window.CollectionGridDensity = {
  isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  },

  getDefault() {
    return DEFAULT_COLUMNS;
  },

  getStored() {
    try {
      const value = localStorage.getItem(STORAGE_KEY);
      if (ALLOWED.has(value)) return value;
    } catch (e) {
      /* localStorage unavailable */
    }
    return null;
  },

  getColumns() {
    return this.getStored() || this.getDefault();
  },

  columnsToIndex(columns) {
    const index = COLUMNS.indexOf(String(columns));
    return index === -1 ? 0 : index;
  },

  indexToColumns(index) {
    return COLUMNS[index] || COLUMNS[0];
  },

  apply(columns) {
    const cols = ALLOWED.has(String(columns)) ? String(columns) : this.getColumns();
    const grid = document.getElementById('product-grid');

    if (grid) {
      grid.className = grid.className.replace(/grid--\d+-col-desktop/g, `grid--${cols}-col-desktop`);
      if (!/grid--\d+-col-desktop/.test(grid.className)) {
        grid.classList.add(`grid--${cols}-col-desktop`);
      }
    }

    document.documentElement.setAttribute('data-collection-grid-columns', cols);

    document.querySelectorAll('grid-density-control').forEach((control) => {
      control.sync(cols);
    });

    this.initDock();

    return cols;
  },

  save(columns) {
    const cols = String(columns);
    if (!ALLOWED.has(cols)) return;
    try {
      localStorage.setItem(STORAGE_KEY, cols);
    } catch (e) {
      /* localStorage unavailable */
    }
    this.apply(cols);
  },

  getInlineControl() {
    return (
      document.querySelector('.facets-toolbar-meta grid-density-control') ||
      document.querySelector('grid-density-control:not(.grid-density-dock)')
    );
  },

  getDock() {
    return document.querySelector('grid-density-control.grid-density-dock');
  },

  createDock(inline) {
    const dock = inline.cloneNode(true);
    dock.classList.add('grid-density-dock');
    dock.dataset.bound = 'false';
    dock.removeAttribute('data-bound');

    const slider = dock.querySelector('.grid-density__slider');
    const label = dock.querySelector('.grid-density__label');
    if (slider) slider.id = 'GridDensitySlider-dock';
    if (label) label.setAttribute('for', 'GridDensitySlider-dock');

    document.body.appendChild(dock);
    return dock;
  },

  updateDockVisibility() {
    const dock = this.getDock();
    const inline = this.getInlineControl();
    if (!dock) return;

    if (this.isMobile() || !inline) {
      dock.classList.remove('is-visible');
      return;
    }

    const rect = inline.getBoundingClientRect();
    const scrolledPast = rect.bottom < 0;
    dock.classList.toggle('is-visible', scrolledPast);
  },

  initDock() {
    const inline = this.getInlineControl();
    if (!inline) return;

    let dock = this.getDock();
    if (!dock) dock = this.createDock(inline);

    if (this._dockObserver) this._dockObserver.disconnect();

    this._dockObserver = new IntersectionObserver(
      () => this.updateDockVisibility(),
      { threshold: [0, 1] }
    );
    this._dockObserver.observe(inline);

    if (!this._dockScrollBound) {
      this._dockScrollBound = true;
      window.addEventListener('scroll', () => this.updateDockVisibility(), { passive: true });
      window.addEventListener('resize', () => this.updateDockVisibility());
    }

    this.updateDockVisibility();
  },
};

class GridDensityControl extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('.grid-density__slider');
    if (!this.slider) return;

    if (this.dataset.bound === 'true') {
      this.sync(window.CollectionGridDensity.getColumns());
      return;
    }
    this.dataset.bound = 'true';

    const onChange = (event) => {
      event.stopPropagation();
      const columns = window.CollectionGridDensity.indexToColumns(Number(this.slider.value));
      window.CollectionGridDensity.save(columns);
    };

    this.slider.addEventListener('input', onChange);
    this.slider.addEventListener('change', onChange);

    window.CollectionGridDensity.apply();
    if (!this.classList.contains('grid-density-dock')) {
      window.CollectionGridDensity.initDock();
    }
  }

  sync(columns) {
    if (!this.slider) {
      this.slider = this.querySelector('.grid-density__slider');
    }
    if (!this.slider) return;

    const index = window.CollectionGridDensity.columnsToIndex(columns);
    this.slider.value = String(index);
    this.slider.setAttribute('aria-valuenow', String(index));
    this.slider.setAttribute('aria-valuetext', `${columns} columns`);
  }
}

if (!customElements.get('grid-density-control')) {
  customElements.define('grid-density-control', GridDensityControl);
}
